import { Component, computed, input } from '@angular/core';
import type { OnyxAmount } from '@onyx/angular';
import { DictionaryCode } from '../../../enums/dictionary-code';
import type { VatRate } from '../../../enums/vat-rate';
import { CommonHelper } from '../../../helpers/common.helper';
import { AmountCellComponent } from '../amount-cell/amount-cell.component';
import { StringCellComponent } from '../string-cell/string-cell.component';

@Component({
  selector: 'app-order-vat-cell',
  imports: [StringCellComponent, AmountCellComponent],
  templateUrl: './order-vat-cell.component.html',
  styleUrl: './order-vat-cell.component.scss',
})
export class OrderVatCellComponent {
  public readonly vatRate = input.required<
    Pick<OnyxAmount, 'value' | 'currency'> & { vatRate: VatRate }
  >();

  protected readonly DictionaryCode = DictionaryCode;

  protected vatValue = computed(() => {
    const vatRate = this.vatRate().vatRate;
    return CommonHelper.isNumeric(vatRate) ? +vatRate : null;
  });
}
